import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { WindowRef } from '@x/common/browser';
import { CookieBotService } from '@x/common/cookie-bot/cookie-bot.service';
import { Logger } from '@x/common/log';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConvertExperimentsService {
  private renderer: Renderer2;

  constructor(
    private windowRef: WindowRef,
    private rendererFactory: RendererFactory2,
    private cookieBotService: CookieBotService,
    private log: Logger,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  async injectScript(scriptUrl: string): Promise<boolean> {
    try {
      // Wait for cookie consent before loading the script
      await firstValueFrom(this.cookieBotService.cookieConsent$.pipe(filter(Boolean)));
      await this.loadScript(scriptUrl);
      return true;
    } catch (error) {
      this.log.error('Error injecting ConvertExperiments script', error);
      return false;
    }
  }

  private async loadScript(scriptUrl: string): Promise<void> {
    try {
      const script: HTMLScriptElement = this.windowRef.document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.src = scriptUrl;

      this.renderer.appendChild(this.windowRef.document.head, script);

      this.log.log('ConvertExperiments: Script loaded successfully!');
    } catch (error) {
      this.log.error('Error loading ConvertExperiments script', error);
      throw error;
    }
  }
}